// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"SectionTitle--next-sr-only--1xeBRms","mainBox":"SectionTitle--mainBox--18F-dEB","preface":"SectionTitle--preface--3CoIKVV","title":"SectionTitle--title--1o-lyFD"};